export const citizenMembershipsTypes = {
	citizen: {
		label: "کاربر خانگی",
		value: 1,
	},
	guild:{
		label: "کاربر صنفی",
		value: 2,
	}
};
